export const COLUMNS = [
    {
        Header: 'Görsel',
        accessor: 'image', // accessor is the "key" in the data
    },
    {
        Header: 'Ürün Adı',
        accessor: 'name',
    },
    {
        Header: 'Ürün Kodu',
        accessor: 'code',
    },
    {
        Header: 'Ürün Açıklaması',
        accessor: 'description',
    },
    {
        Header: 'Ekleyen',
        accessor: 'user',
    },
    {
        Header: 'İşlemler',
        accessor: 'icons',
    },
]